import { useMemo, useState } from 'react';
import { useExperiment } from '~/systems/experiment';

export const useExportModalActions = () => {
  const { exportPulser, name, undoStack } = useExperiment();
  const [overwritingAction, setOverwritingAction] = useState<
    (() => void) | undefined
  >(undefined);

  const isConfirmOverwriteModalVisible = useMemo(
    () => !!overwritingAction,
    [overwritingAction]
  );

  function experimentHasBeenUpdated() {
    return undoStack.canUndo() || undoStack.canRedo();
  }

  function exportPulserSequence() {
    const exported = exportPulser();
    const blob = new Blob([JSON.stringify(exported, null, '    ')], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name}.pulser.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  function openConfirmOverwriteModal(action: () => void) {
    if (experimentHasBeenUpdated()) {
      setOverwritingAction(() => action);
    } else {
      action();
    }
  }

  function handleCancelOverwrite() {
    setOverwritingAction(undefined);
  }

  function handleConfirmOverwrite(save: boolean) {
    if (save) {
      exportPulserSequence();
    }
    if (overwritingAction !== undefined) {
      overwritingAction();
    }
    setOverwritingAction(undefined);
  }

  return {
    experimentHasBeenUpdated,
    exportPulserSequence,
    openConfirmOverwriteModal,
    handleCancelOverwrite,
    handleConfirmOverwrite,
    isConfirmOverwriteModalVisible
  };
};
